import React, { useState } from 'react';
import '../styles/style.css'; 
import Navbar from '../components/navbar'; 
import Footer from '../components/footer';

const App = () => {
    // Estado para controlar o modal e a imagem exibida
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalImageSrc, setModalImageSrc] = useState('');

    // Função para abrir o modal com a imagem selecionada
    const openModal = (imageSrc) => {
        setModalImageSrc(imageSrc);
        setIsModalOpen(true);
    };

    // Função para fechar o modal
    const closeModal = () => {
        setIsModalOpen(false);
        setModalImageSrc('');
    };

    return (
        <div>
            {/* Modal para exibir a imagem maior */}
            {isModalOpen && (
                <div id="imageModal" className="modal" style={{ display: 'block' }}>
                    <div className="modal-content">
                        <span className="close-btn" onClick={closeModal}>&times;</span>
                        <img id="modalImage" src={modalImageSrc} alt="Imagem Modal" />
                    </div>
                </div>
            )}

            <Navbar />
            {/* Secção de Mármores */}
            <section className="pedras" id="marmores">
                <h2 className="section-title">Mais Recomendados</h2>
                <div className="container">
                    <div className="grid-container-marmores">
                        <div className="pedra-item" onClick={() => openModal('https://www.galrao.com/wp-content/uploads/2024/09/marmore-estremoz-branco-1.jpg')}>
                            <img src="https://www.galrao.com/wp-content/uploads/2024/09/marmore-estremoz-branco-1.jpg" alt="Mármore Branco" />
                            <div className="info">
                                <h3>Mármore Estremoz</h3>
                            </div>
                        </div>
                        <div className="pedra-item" onClick={() => openModal('https://www.dimpomar.com/xms/img/1200x/4cf9b/cT05MCZmbHRyW109/L08zbS8tME0zWnJTbS95NHNnWjd1blpGc2E3akpTbS8zakZTWkpqbXQ0dGRrcg.jpg')}>
                            <img src="https://www.dimpomar.com/xms/img/1200x/4cf9b/cT05MCZmbHRyW109/L08zbS8tME0zWnJTbS95NHNnWjd1blpGc2E3akpTbS8zakZTWkpqbXQ0dGRrcg.jpg" alt="Mármore Branco" />
                            <div className="info">
                                <h3>Mármore Mulianes</h3>
                            </div>
                        </div>
                        <div className="pedra-item" onClick={() => openModal('https://www.normamargem.pt/wp-content/uploads/2018/08/Ruivina-escura-1.png')}>
                            <img src="https://www.normamargem.pt/wp-content/uploads/2018/08/Ruivina-escura-1.png" alt="Mármore Branco" />
                            <div className="info">
                                <h3>Mármore Ruivina</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Secção de Mármores Nacionais */}
            <section className="pedras" id="marmores">
                <h2 className="section-title">Mármores Nacionais</h2>
                <div className="container">
                    <div className="grid-container-marmores-nacionais">
                        {[
                            { nome: "Alpina", img: "https://www.marmoramos.pt/thumbs/pedras-naturais/marmores/amarelo-negrais-1-800x600-q70.webp" },
                            { nome: "Amarelo Negrais", img: "https://www.marmoramos.pt/thumbs/pedras-naturais/marmores/amarelo-negrais-1-800x600-q70.webp" },
                            { nome: "Ataíja Azul", img: "https://www.marmoramos.pt/thumbs/pedras-naturais/marmores/ataija-azul-800x600-q70.webp" },
                            { nome: "Azul Valverde", img: "https://www.marmoramos.pt/thumbs/pedras-naturais/marmores/azul-valverde-polido-1-800x600-q70.webp" },
                            { nome: "Brecha Tavira", img: "https://www.marmoramos.pt/thumbs/pedras-naturais/marmores/brecha-tavira-800x600-q70.webp" },
                            { nome: "Estremoz c/ Veio Castanho", img: "https://www.marmoramos.pt/thumbs/pedras-naturais/marmores/estremoz-veio-castanho-800x600-q70.webp" },
                            { nome: "Estremoz Creme", img: "https://www.marmoramos.pt/thumbs/pedras-naturais/marmores/estremoz-creme-800x600-q70.webp" },
                            { nome: "Estremoz Rosa", img: "https://www.marmoramos.pt/thumbs/pedras-naturais/marmores/estremoz_rosa-800x600-q70.webp" },
                            { nome: "Estremoz Branco c/ Veio Azul", img: "https://www.marmoramos.pt/thumbs/pedras-naturais/marmores/marmore-estremoz-branco-com-veios-azuis-800x600-q70.webp" },
                            { nome: "Estremoz Branco Extra", img: "https://www.marmoramos.pt/thumbs/pedras-naturais/marmores/marmore-estremoz-branco-extra-800x600-q70.webp" },
                            { nome: "Estremoz Pele de Tigre", img: "https://www.marmoramos.pt/thumbs/pedras-naturais/marmores/marmore-estremoz-pele-de-tigre-800x600-q70.webp" },
                            { nome: "Lioz Creme", img: "https://www.marmoramos.pt/thumbs/pedras-naturais/marmores/lioz_creme-800x600-q70.webp" },
                            { nome: "Lioz Abancado", img: "https://www.marmoramos.pt/thumbs/pedras-naturais/marmores/lioz-abancado-800x600-q70.webp" },
                            { nome: "Moca Creme", img: "https://www.marmoramos.pt/thumbs/pedras-naturais/marmores/marmore-moca-creme-800x600-q70.webp" },
                            { nome: "Ruivina Preta", img: "https://www.marmoramos.pt/thumbs/pedras-naturais/marmores/marmores-nacionais-ruivina-preta-800x600-q70.webp" },
                            { nome: "Vermelho Negrais", img: "https://www.marmoramos.pt/thumbs/pedras-naturais/marmores/vermelho-negrais-800x600-q70.webp" },
                            { nome: "Vidraço Ataíja", img: "https://www.marmoramos.pt/thumbs/pedras-naturais/marmores/vidraco-ataija-beje-1-800x600-q70.webp" },
                            { nome: "Vidraço Moleanos", img: "https://www.marmoramos.pt/thumbs/pedras-naturais/marmores/vidraco-moleanos-1-800x600-q70.webp" }
                        ].map((marmore, index) => (
                            <div className="pedra-item" key={index} onClick={() => openModal(marmore.img)}>
                                <img src={marmore.img} alt={marmore.nome} />
                                <div className="info">
                                    <h3>{marmore.nome}</h3>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    );
};

export default App;
